export const URL_API = 'https://restau-ossier-backend.lce-ci.com/api/';
export const URL = 'https://restau-ossier-backend.lce-ci.com/';
//export const URL_API = 'http://192.168.1.4:8003/api/';

export const URL_AUTH_API = 'https://restau-ossier-backend.lce-ci.com/api/auth/';
//export const URL_AUTH_API = 'http://192.168.1.4:8003/api/auth/';